import {Component, ViewChild} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FlatTreeControl } from '@angular/cdk/tree';
import {MatTreeFlattener, MatTreeFlatDataSource, MatSidenav} from '@angular/material';
import { environment } from '../../environments/environment';
import { AppConfigService } from '../app-config.service';
import {MatDialog} from '@angular/material/dialog';
import {LoginFormComponent} from '../login-form/login-form.component';
import {AuthService} from '../services/auth-service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from '../services/configuration.service';
import { Configuration } from '../interface/configuration.interface';
/**
 * Food data with nested structure.
 * Each node has a name and an optiona list of children.
 */
interface FoodNode {
  name: string;
  icon: string;
  url?: string;
  children?: FoodNode[];
}

const TREE_DATA: FoodNode[] = [
  {
    name: 'Inicio',
    icon: 'home',
    url: '/'
  },
  {
    name: 'Generar factura',
    icon: 'assignment',
    url: '/generaF'
  },
  {
    name: 'Refacturación',
    icon: 'restore_page',
    url: '/refacturacion'
  },
  {
    name: 'Lista Datos Fiscales',
    icon: 'list',
    url: '/listDatosF'
  },
  {
    name: 'Mis facturas',
    icon: 'image_search',
    url: '/cItuF'
  },
  {
    name: 'Dudas frecuentes',
    icon: 'description',
    children: [
      {name: 'Tipo de ITU´s', icon: 'chrome_reader_mode', url: '/itusTypes'},
      {name: 'Genera factura', icon: 'chrome_reader_mode', url: '/guideInvoice'},
      {name: 'Refacturación', icon: 'chrome_reader_mode', url: '/guideReinvoice'},
      {name: 'Consulta e impresión de F.E', icon: 'chrome_reader_mode', url: '/guideConsult'},
      {name: 'F.A.Q.', icon: 'chrome_reader_mode', url: '/faq'},
    ]
  }
];

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  icon: string;
  level: number;
}

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css']
})

export class MainNavComponent {
  @ViewChild('contentMsg') contenidoDelModal;
  inactivityTime = 0;
  inactivityTimer: any;

  isLoggedIn = false;
  userName = '';

  panelOpenState = false;

  // menu: MenuInterface[] = [];
  menu: any[] = [];
  @ViewChild('drawer') drawer!: MatSidenav;
  msg = 'Imposible conectar con el servidor';

  logotype = '';
  logoHeader = '';
  colorTexto = '';
  colorBtn = '';
  width = '100%';
  txtMsg = '';
  companyName = '';

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      icon: node.icon,
      url: node.url,
      level: level,
    };
  }

// tslint:disable-next-line: member-ordering
  treeControl = new FlatTreeControl<ExampleFlatNode>(
      node => node.level, node => node.expandable);

// tslint:disable-next-line: member-ordering
  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

// tslint:disable-next-line: member-ordering
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(private router: Router,
              private breakpointObserver: BreakpointObserver,
              private configService: AppConfigService,
              private dialog: MatDialog,
              private authService: AuthService,
              private snackBar: MatSnackBar,
              config: NgbModalConfig,
              private modalService: NgbModal,
              private configurationService: ConfigurationService
  ) {

    // this.isLoggedIn = this.authService.getIsLoggedIn();
    // this.userName = this.authService.getUser();
    this.companyName = this.configService.getConfig().companyName;
    config.backdrop = 'static';
    config.keyboard = false;
    this.logotype = this.configService.getConfig().logotype;
    this.logoHeader = this.configService.getConfig().logoHeader;
    this.colorTexto = this.configService.getConfig().colorTexto;
    this.colorBtn = this.configService.getConfig().colorBtn;
    if (this.configService.getConfig().companyName === 'RS') {
      this.width = this.configService.getConfig().width;
      console.log('Width cargado desde config:', this.width);
    }
    if (this.configService.getConfig().internal) {
      TREE_DATA[3].children.push({name: 'R.F.C.', icon: 'looks_two', url: '/cRfcF'});
    }
    this.dataSource.data = TREE_DATA;

  }

  ngOnInit() {

    this.configurationService.getParamMaintenance().subscribe((data: Configuration) => {
      console.log('DATA: ', data);
      if(data.configValue == '1') {
        this.modalService.open(this.contenidoDelModal);
      }
    });
    this.configurationService.getTextMaintenance().subscribe((data: Configuration) => {
      console.log('DATA: ', data);
      this.txtMsg = data.configValue;
    });

    if (localStorage.getItem('user')) {
      this.userName = localStorage.getItem('user');
      this.isLoggedIn = true;
    }

    // Detectar actividad del usuario
    this.resetInactivityTimer();

    // Detectar eventos de actividad
    window.addEventListener('mousemove', this.resetInactivityTimer.bind(this));
    window.addEventListener('keydown', this.resetInactivityTimer.bind(this));

    // Establecer un tiempo de inactividad de 15 minutos (900,000 ms)
    const inactivityLimit = 900000;

    this.inactivityTimer = setInterval(() => {
      this.inactivityTime += 1000;
      if (this.inactivityTime >= inactivityLimit) {
        this.logout();
      }
    }, 1000);
  }

  resetInactivityTimer(): void {
    this.inactivityTime = 0;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(LoginFormComponent, {
      width: '400px' // Tamaño del modal
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoggedIn = true;
        this.userName = localStorage.getItem('user');
      }
    });
  }

  logout() {
    this.authService.logout();
    this.isLoggedIn = false;
    this.userName = '';

    this.snackBar.open('Se cerró la sesión correctamente.', 'Cerrar', {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: 'success-snackbar'
    });
  }

  closeMenu(drawer: MatSidenav): void {
    if (window.innerWidth < 768) {
      drawer.close();
    }
  }


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  seeGuide( param ) {
    console.log('Ver guía!!!');
  }
}
